import { useState } from 'react';
import {
    IconButton,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import NavigationMenu from './NavigationMenu';
import './NavigationMenuIcon.scss';

/**
 * @param {{
 *  managerPageSelected: number,
 * }} props
 */
function NavigationMenuIcon(props) {
    const { managerPageSelected } = props;
    const [isNavBarOpen, setIsNavBarOpen] = useState(false);
    return (
        <div className="nvi-container">
            <IconButton onClick={() => setIsNavBarOpen((state) => !state)}>
                <Menu />
            </IconButton>
            <NavigationMenu
                extended={isNavBarOpen}
                handleClose={() => setIsNavBarOpen(false)}
                managerPageSelected={managerPageSelected}
            />
        </div>
    );
}
export default NavigationMenuIcon;
